import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../config/config';
import { Observable }     from 'rxjs/Observable';

@Injectable()
export class MenuService {

    constructor(private http: Http) { }

    GetMenu(username: string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        let data = { TaiKhoan: username };
        return this.http.post(Config.apiUrl + 'General/GetMenu', JSON.stringify(data), { headers: headers }).map(resp => resp.json());                
    }
    GetQuickLink(){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'General/GetQuickLink', { headers: headers }).map(resp => resp.json());
    }
    DanhSach_CanhBao() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {}
        return this.http.post(Config.apiUrl + 'XLXuLy/DanhSach_CanhBao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/vnpt-menu.service.ts